import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'inputError',
})
export class InputErrorPipe implements PipeTransform {
  transform(value: any): string {
    if (value.hasOwnProperty('required')) {
      return 'Error.Required';
    } else if (value.hasOwnProperty('minlength')) {
      return 'Error.MinLength';
    } else if (value.hasOwnProperty('maxlength')) {
      return 'Error.MaxLength';
    } else if (value.hasOwnProperty('email')) {
      return 'Error.Email';
    } else if (value.hasOwnProperty('pattern')) {
      return 'Error.RequiredPattern';
    } else if (value.hasOwnProperty('passwordNotSame')) {
      return 'Error.PasswordNotSame';
    } else if (value.hasOwnProperty('passwordIncorrect')) {
      return 'Error.PasswordIncorrect';
    } else if (value.hasOwnProperty('max')) {
      return 'Error.Max';
    } else if (value.hasOwnProperty('min')) {
      return 'Error.Min';
    } else if (value.hasOwnProperty('ValueNotMatch')) {
      return 'Error.ValueNotMatch';
    } else if (value.hasOwnProperty('emailExisted')) {
      return 'Error.EmailExisted';
    } else if (value.hasOwnProperty('emailNotFound')) {
      return 'Error.EmailNotFound';
    } else if (value.hasOwnProperty('tooManyLoginRequests')) {
      return 'Error.TooManyLoginRequests';
    } else if (value.hasOwnProperty('emailBlocked')) {
      return 'Error.EmailBlocked';
    } else if (value.hasOwnProperty('emailDeactivated')) {
      return 'Error.EmailDeactivated';
    } else if (value.hasOwnProperty('emailPending')) {
      return 'Error.EmailPending';
    } else if (value.hasOwnProperty('fileSizeLimitExceeded')) {
      return 'Error.FileSizeLimitExceeded';
    } else if (value.hasOwnProperty('invalidPhone')) {
      return 'Global.Error.PhoneInvalid';
    } else if (value.hasOwnProperty('invalidFrenchPhone')) {
      return 'Global.Error.FrenchPhoneInvalid';
    }
    return '';
  }
}
